<template>
  <div class="HalfSphere flexColumn">
    <h1 class="HalfSphere-header page-title">
      Расчет полусферы
    </h1>
    <div class="HalfSphere-diameter_sphere flexColumn">
      Диаметр сферы мм.
      <div class="HalfSphere-diameter_sphere-input">
        <CastomInput
          v-model="sphereDiameter"
        />
      </div>
      <img class="image" :src="require('../../../images/icons/halfSphere.svg')">
    </div>
    <div class="circle_text">
      Диаметр заготовки мм.
    </div>
    <div class="HalfSphere-diameter flexRow">
      <div class="HalfSphere-diameter-circle">
        <div v-if="diskDiameter">
          {{diskDiameter}} мм.
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import CastomInput from '../../inputs/CastomInput'
import { ref, computed} from 'vue'
import { useComputedCalculationTracking } from '@/helpers/calculationAnalytics'

const sphereDiameter = ref(0)
if (window.gtag) {
  window.gtag('event', 'sphere_calculator', {})
}
const diskDiameter = computed(()=>{
  if(sphereDiameter.value) {
    return (sphereDiameter.value*1.4).toFixed(2)
  } else {
    return 0
  }
})
useComputedCalculationTracking('half_sphere', diskDiameter)
</script>

<style scoped lang="scss">
.HalfSphere{
  justify-content: space-around;
  height: calc(100vh - 140px);;
  width: 100%;
  text-align: center;
  color: white;
  &-header {
    padding: 10px;
    border-top: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    border-right: none;
    border-left: none;
   }
  &-diameter_sphere {
    position: relative;
    align-items: center;
   &-input  {
     position: absolute;
     width: 100px;
     left: 50%;
     top: 47%;
     z-index: 100;
     transform: translate(-50%, -50%);
   }
  }
  &-diameter {
    align-items: center;
    text-align: center;
    justify-content: center;
    &-circle {
      border-radius: 100%;
      height: 140px;
      width: 140px;
      border: 6px solid #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
  }
}

.flexColumn {
  display: flex;
  flex-direction: column;
}
.flexRow {
  display: flex;
  flex-direction: row;
}
.image {
  height: 150px;
  width: 150px;
  filter: invert(100%) sepia(26%) saturate(1374%) hue-rotate(189deg) brightness(96%) contrast(91%);
}
.circle_text {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
